import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import qs from 'qs';

import { API_URL, get } from 'lib/network/api';

import FullLayout from 'layout/FullLayout';
import CardClass from 'components/CardClass';
import Modal from 'components/Modal';
import ContentCardPass from 'components/ContentCardPass';

const ClassPass = () => {
  const navigation = useNavigate();
  const [searchParams] = useSearchParams();
  const currentParams = qs.parse(searchParams.toString(), { comma: true });
  const [openQuickShow, setOpenQuickShow] = useState(false);
  const [selectedPass, setSelectedPass] = useState(null);
  const [query, setQuery] = useState({
    page: 1,
    limit: 50,
  });

  const fetchListClass = async (query, currentParams) => {
    const { page, limit } = currentParams;

    const params = {
      page: page ? page : query.page,
      limit: limit ? limit : query.limit,
      category: 0,
    };

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== undefined && value !== null && value !== '',
      ),
    );

    return get(
      `${API_URL}/api/event/package/no-login?${qs.stringify(filteredParams, {
        arrayFormat: 'repeat',
      })}`,
    );
  };

  const { data, isLoading, isError } = useQuery({
    queryKey: ['fetchListClass', query, currentParams],
    queryFn: async ({ queryKey }) => fetchListClass(queryKey[1], queryKey[2]),
  });

  const classPackage = data?.data || [];
  const pagination = data?.pagination || {};

  const onSelectedPass = (item) => {
    setOpenQuickShow(true);
    setSelectedPass(item);
  };

  const onCheckout = (id) => {
    navigation(`/checkout?package_type=event_package&package_id=${id}`);
  };

  return (
    <FullLayout>
      <div className="container mx-auto pt-6 pb-24 px-4 xl:px-0">
        <div className="h-[250px] xl:h-[370px] relative">
          <img
            alt="class"
            src="/kin/assest/image/class-pass.webp"
            className="absolute inset-0 h-full w-full object-cover rounded-lg"
          />
          <span className="absolute inset-0 flex items-center justify-center text-white font-bold text-2xl">
            Class Passes
          </span>
        </div>

        {/* Loading State */}
        {isLoading && <p className="text-center mt-6">Loading...</p>}

        {/* Error State */}
        {isError && (
          <p className="text-center mt-6 text-red-500">Terjadi kesalahan saat memuat data.</p>
        )}

        {/* Data Kosong */}
        {!isLoading && classPackage.length === 0 && (
          <p className="text-center mt-6 text-gray-500">Tidak ada data yang tersedia.</p>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mt-6 pb-20 gap-4">
          {classPackage.map((items, idx) => {
            return (
              <CardClass
                context="list"
                key={idx}
                item={items}
                onQuickView={onSelectedPass}
                onCheckout={onCheckout}
              />
            );
          })}
        </div>

        {openQuickShow && (
          <Modal
            open={openQuickShow}
            onRequestClose={() => setOpenQuickShow(false)}
            clickOverlay={true}>
            <ContentCardPass item={selectedPass} onClose={setOpenQuickShow} type={'view'} />
          </Modal>
        )}
      </div>
    </FullLayout>
  );
};

export default ClassPass;
